module.exports = __webpack_public_path__ + "img/celule-imunitare.387ed293.png";